const KEY = "theme";

export const getTheme = () =>
  document.documentElement.getAttribute("data-theme") || "dark";

export function initialTheme() {
  try {
    const saved = localStorage.getItem(KEY);
    if (saved === "light" || saved === "dark") return saved;
  } catch (e) {
    /* storage blocked */
  }
  return window.matchMedia &&
    window.matchMedia("(prefers-color-scheme: light)").matches
    ? "light"
    : "dark";
}

export function setTheme(mode) {
  document.documentElement.setAttribute("data-theme", mode);
  try {
    localStorage.setItem(KEY, mode);
  } catch (e) {
    /* storage blocked */
  }
  window.dispatchEvent(new CustomEvent("themechange", { detail: mode }));
}

// Pick an icon colour that stays readable on the current background:
// near-black brand colours switch to the theme's ink colour.
export function adaptiveIconStyle(style = {}) {
  const c = style.color;
  const m = typeof c === "string" && c.match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i);
  if (!m) return style;
  let h = m[1];
  if (h.length === 3) h = h.split("").map((x) => x + x).join("");
  const [r, g, b] = [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16));
  const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return lum < 0.3 ? { ...style, color: "var(--icon-ink)" } : style;
}
